import { ReactNode } from 'react';

export const BarItem = ({
  children,
  width,
  background,
  classNames,
}: {
  children: ReactNode;
  width: string;
  background?: string;
  classNames?: string;
}) => {
  return (
    <div
      className={`ease-in-out duration-300 mobile:text-xs text-sm rounded-md flex flex-col items-center justify-center h-[90px]  text-center p-[4px] min-w-[68px] ${classNames}`}
      style={{
        width,
        background,
      }}
    >
      {children}
    </div>
  );
};
